module.exports = __webpack_public_path__ + "img/techno-heart.6f8c8cd3.svg";